<div [class]="class" ngbAccordion>
	<div ngbAccordionItem [collapsed]="false">
		<h2 ngbAccordionHeader>
			<button 
				class="d-flex align-items-center border-0 text-success h6 font-weight-normal w-100 px-2 py-1" 
				ngbAccordionButton (click)="toggleArrowIconHandler()"
			>
				<i [class]="isToggleOn ? downArrowClass : rightArrowClass" aria-hidden="true"></i>
				<span>{{headerName}}</span>
			</button>
		</h2>

		<div ngbAccordionCollapse>
			<div ngbAccordionBody>
				<ng-content></ng-content>
			</div>
		</div>
	</div>
</div>